module.exports = __webpack_public_path__ + "img/header-en.e00310e7.jpg";